import { Configuration, S3Api } from "@lj-island/peachy-religion-client";

const s3Provider = (config: Configuration) => {

	return {
		upload: async(file: File) => {
			const filesApi = new S3Api(config)
			const { data } = await filesApi.uploadAsset(file.type, 'false')
			const result = data as any

			const body = new FormData()
			for(const field in result.fields) {
				body.append(field, result.fields[field])
			}
	
			body.append('file', file)
	
			const postResult = await fetch(result.url, {
				method: 'POST',
				body,
			})
			if(postResult.status >= 400) {
				throw new Error('Upload failed')
			}
	
			return result.url + '/' + result.fields.key
		}
	}
}

export default s3Provider